<template>
  <div>
    <div class="modal" id="modal-notification" tabindex="-1" role="dialog">
      <div class="modal-dialog modal- modal-dialog-centered modal-" role="document">
        <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" id="modal-title-notification">Chi tiết lịch hẹn </h6>
              <button type="button" class="close" @click="close_modal" data-dismiss="modal">
                  <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div>Tên cố vấn: {{appointment_detail.counselor_name}}</div>
              <div>Email cố vấn: {{appointment_detail.counselor_email}}</div>
              <div>Tên người đặt: {{appointment_detail.customer_name}}</div>
              <div>Email người đặt: {{appointment_detail.customer_email}}</div>
              <div>Địa chỉ người đặt: {{appointment_detail.customer_address}}</div>
              <div>Trình độ học vấn cao nhất: {{appointment_detail.level_education}}</div>
              <div>Điểm GPA: {{appointment_detail.GPA_score}}</div>              
              <div>Ngày hẹn: {{appointment_detail.date_meeting}}</div>
              <div>Thời điểm gặp mặt: {{appointment_detail.time_of_the_day}}</div>
              <div>Câu hỏi: {{appointment_detail.question}}</div>
              <div>Điểm chuẩn hóa:
                <div v-for="score in appointment_detail.score">
                  <div>{{score['name']}}: {{score['score']}}</div>
                </div>
              </div>
              <!-- <pre>{{appointment_detail}}</pre> -->
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-white" @click="close_modal">Đóng</button>
            </div>
        </div>
      </div>
  </div>
  </div>  

</template>
<script>
import {mapState} from 'vuex';
  export default{
    props: {
      show_modal_detail_appointment:{
        type: Boolean
      }, 
    },
    methods: {      
      close_modal: function () {
        this.show_modal_detail_appointment = false;
        this.$emit('close_modal', this.show_modal_detail_appointment)
      }
    },
    computed:{
      ...mapState('vuex_admin',[
        'appointment_detail'
      ]),
    }
  };
</script>
<style lang="scss" scoped>
  #modal-notification.modal{
    display: unset;
    .modal-content{
      max-height: 500px;
      overflow-y: scroll;
      .modal-body{
        word-break: break-word
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/components/Modal/DetailAppointmentModal.vue